import React from 'react';
import './Event.css';

function Event() {
    return (
        <div className="event-container">
            <div className="event-image">
                <img src={`${process.env.PUBLIC_URL}/event.jpg`} alt="Event Poster" />
            </div>
            <div className="event-details">
                <h1>Pick & Sell Perform Festival 🎸</h1>
                <p>청춘 밴드를 위한 특별한 무대!</p>
                <ul>
                    <li>🎶 합주실 무료 제공</li>
                    <li>🎥 공연 영상 촬영 지원</li>
                    <li>🏆 상위 밴드 공연 참가 기회 제공</li>
                </ul>
                <p>📅 2025년 3월 17일</p>
                <p>📍 Pick & Sell Studio</p>
                <p>123 Mangu St. Jung-lang</p>
                <p>멋진 추억을 남길 수 있는 기회를 놓치지 마세요!</p>
                <p>지금 바로 참여 신청하세요! 🔥</p>
                <button className="apply-button">신청하기</button>
            </div>
        </div>
    );
}

export default Event;
